import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  private _isExpanded = signal(false);

  get isExpanded() {
    return this._isExpanded.asReadonly();
  }

  toggle() {
    this._isExpanded.update((val) => !val);
  }

  set(value: boolean) {
    this._isExpanded.set(value);
  }
}
